module.exports = __webpack_public_path__ + "img/kimi-1.7cf85ed5.png";